// Module
var code = "<div class=\"flex-column radio-grp {{standardStyling ? '' : 'custom'}}\"> <% _.each(dataSource, function(item) { %> <label> <input type=\"radio\" class=\"with-gap\" name=\"{{this}}\" value=\"{{item.value}}\"/> <span>{{item.name}}</span> </label> <% }, name); %> </div> ";
// Exports
export default code;